// ContactPage.jsx
import { useState } from 'react';
import './css/contact.css';

const Contact = () => {
    const url = process.env.REACT_APP_SERVER_URL;
    const support_mail = process.env.REACT_APP_APP_SUPPOE_MAIL
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        inquiryType: 'general',
        subject: '',
        message: ''
    });

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitMessage, setSubmitMessage] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitMessage('');

        try {
            await new Promise(resolve => setTimeout(resolve, 1000));

            const Response = await fetch(`${url}/api/contact`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(formData)
            })

            const data = await Response.json();
            if (data.status === 1) {
                setSubmitMessage(data.message);
                setFormData({
                    name: '',
                    email: '',
                    phone: '',
                    inquiryType: 'general',
                    subject: '',
                    message: ''
                });
            }
            if(data.status === 0){
                setSubmitMessage(data.message);
            }
        } catch (error) {
            setSubmitMessage('Something went wrong. Please try again or call our support.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const contactInfo = [
        {
            icon: <i className="fa-solid fa-location-dot"></i>,
            title: 'Our Location',
            details: '144 Pakariya, Kala Aam\nLakhimpur-kheri\nUttar Pradesh, India\nPin: 262701'
        },
        {
            icon: <i className="fa-solid fa-phone"></i>,
            title: 'Student Support',
            details: '+91 6387139149',
            links: ['tel:+916387139149']
        },
        {
            icon: <i className="fa-solid fa-envelope"></i>,
            title: 'Email Address',
            details: support_mail,
            links: [`mailto:${support_mail}`]
        }
    ];

    const socialLinks = [
        { name: 'YouTube', icon: <i className="fa-brands fa-youtube"></i>, url: 'https://www.youtube.com/channel/UCQ2oXyDnMyc97rSSEbpaBXg' },
        { name: 'Instagram', icon: <i className="fa-brands fa-instagram"></i>, url: 'https://www.instagram.com/examhall_05/' },
        { name: 'WhatsApp', icon: <i className="fa-brands fa-whatsapp"></i>, url: 'https://api.whatsapp.com/send?phone=916387139149' },
        { name: 'Telegram', icon: <i className="fa-brands fa-telegram"></i>, url: 'https://t.me/ashu_233' }
    ];

    const faqItems = [
        {
            question: 'How do I access mock tests?',
            answer: 'After registration, access all mock tests from your dashboard. Tests are available 24/7 with detailed analytics.'
        },
        {
            question: 'Do you provide test analytics?',
            answer: 'Yes! Get detailed performance analytics, time management stats, topic-wise breakdown, and improvement suggestions.'
        },
        {
            question: 'Are tests mobile-friendly?',
            answer: 'Absolutely! Our platform is fully responsive and optimized for all devices - desktop, tablet, and mobile.'
        },
        {
            question: 'Can I get doubt clarification?',
            answer: 'Yes, our subject experts provide doubt clarification within 6 hours. Premium users get priority support.'
        }
    ];

    return (
        <div className="contactPageWrapper">
            
            {/* Header Section */}
            <div className="contactHeaderSection">
                <h2>Get in Touch with Us</h2>
                <p>We're here to help. Reach out to us for technical support, academic queries, or feedback.</p>
            </div>

            <div className="contactMainGrid">
                
                {/* Left Column: Form */}
                <div className="contactFormContainer modernCard">
                    <div className="cardTitleBox">
                        <h3>Send a Message</h3>
                        <p>Fill out the form below and we will get back to you shortly.</p>
                    </div>

                    <form onSubmit={handleSubmit} className="contactForm">
                        <div className="formRow">
                            <div className="inputGroup">
                                <label>Full Name *</label>
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    placeholder="Enter your full name"
                                    required
                                    className="cleanInput"
                                />
                            </div>
                            <div className="inputGroup">
                                <label>Email Address *</label>
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder="your.email@example.com"
                                    required
                                    className="cleanInput"
                                />
                            </div>
                        </div>

                        <div className="formRow">
                            <div className="inputGroup">
                                <label>Phone Number *</label>
                                <input
                                    type="tel"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    placeholder="+91 0000000000"
                                    required
                                    className="cleanInput"
                                />
                            </div>
                            <div className="inputGroup">
                                <label>Inquiry Type *</label>
                                <select
                                    name="inquiryType"
                                    value={formData.inquiryType}
                                    onChange={handleChange}
                                    required
                                    className="cleanInput cleanSelect"
                                >
                                    <option value="general">General Inquiry</option>
                                    <option value="technical">Technical Support</option>
                                    <option value="payment">Payment Issue</option>
                                    <option value="test-access">Test Access Problem</option>
                                    <option value="feedback">Feedback/Suggestion</option>
                                </select>
                            </div>
                        </div>

                        <div className="inputGroup">
                            <label>Subject *</label>
                            <input
                                type="text"
                                name="subject"
                                value={formData.subject}
                                onChange={handleChange}
                                placeholder="e.g., Mock Test Access Issue"
                                required
                                className="cleanInput"
                            />
                        </div>

                        <div className="inputGroup">
                            <label>Message *</label>
                            <textarea
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                placeholder="Describe your issue or inquiry..."
                                rows="5"
                                required
                                className="cleanInput"
                            />
                        </div>

                        {submitMessage && (
                            <div className={`statusAlert ${submitMessage.includes('Thank you') || submitMessage.toLowerCase().includes('success') ? 'alertSuccess' : 'alertError'}`}>
                                <i className={`fa-solid ${submitMessage.includes('Thank you') || submitMessage.toLowerCase().includes('success') ? 'fa-circle-check' : 'fa-triangle-exclamation'}`}></i>
                                <span>{submitMessage}</span>
                            </div>
                        )}

                        <button type="submit" className="primarySubmitBtn" disabled={isSubmitting}>
                            {isSubmitting ? 'Sending Message...' : 'Send Message'}
                        </button>
                    </form>
                </div>

                {/* Right Column: Contact Info & Socials */}
                <div className="contactSidebar">
                    
                    <div className="modernCard infoCard">
                        <h3>Contact Information</h3>
                        <div className="infoList">
                            {contactInfo.map((item, index) => (
                                <div key={index} className="infoListItem">
                                    <div className="infoIconBox">{item.icon}</div>
                                    <div className="infoDetails">
                                        <h4>{item.title}</h4>
                                        {item.links ? (
                                            item.details.split('\n').map((line, idx) => (
                                                <a key={idx} href={item.links[idx]} className="infoLink">{line}</a>
                                            ))
                                        ) : (
                                            <p>{item.details}</p>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="modernCard socialCard">
                        <h3>Connect With Us</h3>
                        <p>Follow us for updates, tips, and study material.</p>
                        <div className="socialIconsWrapper">
                            {socialLinks.map((social, index) => (
                                <a key={index} href={social.url} target="_blank" rel="noopener noreferrer" className="socialIconBtn" title={social.name}>
                                    {social.icon}
                                </a>
                            ))}
                        </div>
                    </div>

                </div>
            </div>

            {/* FAQ Section */}
            <div className="faqSection modernCard">
                <div className="cardTitleBox textCenter">
                    <h3>Frequently Asked Questions</h3>
                    <p>Find quick answers to common queries</p>
                </div>
                <div className="faqGrid">
                    {faqItems.map((faq, index) => (
                        <div key={index} className="faqItem">
                            <div className="faqQ">
                                <span className="faqNum">Q{index + 1}.</span>
                                <h4>{faq.question}</h4>
                            </div>
                            <p className="faqA">{faq.answer}</p>
                        </div>
                    ))}
                </div>
            </div>

        </div>
    );
};

export default Contact;